import { Modal } from 'react-bootstrap';
import React from 'react';
import {useState} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ChangePasswordModal from '../Modal/ChangePasswordModal';

const Sidebar = () => {

  const [showModal, setShowModal] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen]= useState(false);
  const {logout} =useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const getActiveLinkIndex = (pathname) => {
    if (pathname.includes('/dashboard')) return 0;
    if (pathname.includes('/manageProject')) return 1;
    if (pathname.includes('/manageUsers')) return 2;
    return null;
  };

  const activeLink = getActiveLinkIndex(location.pathname);

  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };

  const showPasswordModal = () =>{
    setShowModal(true);
  };

  const closeModal = ()=>{
    setShowModal(false);
    setProfileMenuOpen(false);
  }

  const handleNavigation = () => {
    navigate("/home/api-docs");
    setProfileMenuOpen(false);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-logo-section">
        <img 
          src="/assets/images/logo.png" 
          alt="Logo" 
          className="sidebar-logo" 
        />
      </div>

      <nav className="sidebar-content">
        <ul className="sidebar-icon-list">
          <li 
            className={`sidebar-icon-item ${activeLink === 0 ? 'active' : ''}`}
          >
            <Link to="/home/dashboard" className="sidebar-link">
               <img src='/assets/icons/icon1.svg' className='icon' alt="Dashboard" />
            </Link>
          </li>
          <li 
          className={`sidebar-icon-item ${activeLink === 1 ? 'active' : ''}`}
          >
            <Link to="/home/manageProject" className="sidebar-link">
              <img src='/assets/icons/icon2.svg' className='icon' alt="Settings" />
            </Link>
          </li>
          <li 
           className={`sidebar-icon-item ${activeLink === 2 ? 'active' : ''}`}
          >
            <Link to="/home/manageUsers" className="sidebar-link">
              <img src='/assets/icons/icon3.svg' className='icon' />
            </Link>
          </li>
        </ul>
        <ul className="sidebar-icon-list-end">
          <li 
          className={`sidebar-icon-item ${activeLink === 3 ? 'active' : ''}`}
          >
            <img src='/assets/icons/icon4.svg' className='icon' alt="Profile" onClick={toggleProfileMenu} />
            {profileMenuOpen && (
              <ul className="submenu">
                <li onClick={logout} >Logout</li>
                <li onClick={showPasswordModal}>Change Password</li>
                <li onClick={handleNavigation}>API Documentation</li>
              </ul>
            )}
          </li>
        </ul>
      </nav>
      <ChangePasswordModal show={showModal} handleClose={closeModal} />
    </div>
  );
}

export default Sidebar